import { render, staticRenderFns } from "./PhoneList.vue?vue&type=template&id=bde7afaa"
import script from "./PhoneList.vue?vue&type=script&lang=js"
export * from "./PhoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde7afaa')) {
      api.createRecord('bde7afaa', component.options)
    } else {
      api.reload('bde7afaa', component.options)
    }
    module.hot.accept("./PhoneList.vue?vue&type=template&id=bde7afaa", function () {
      api.rerender('bde7afaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Phone/PhoneList.vue"
export default component.exports